import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { IInstanceModel } from '../../requesters/profile/instance.model';
import {
	AccountResponse,
	IProfileModel,
} from '../../requesters/profile/profile.model';
import { InstanceModule } from '../domain/instance-module';
import { ProductInstanceTypeModel, RoleType } from '../domain/module-role';
import { UserProfile } from '../domain/user-profile';

@Injectable({
	providedIn: 'root',
})
export class ProfileAdapter {
	public generateUserProfile(response: IProfileModel): UserProfile {
		const tuple = response.accounts.map<[number, Array<RoleType>]>((a) => [
			a.organizationId,
			this.generateRoles(a),
		]);
		return UserProfile.build({
			id: response.id,
			userName: response.name ?? '',
			login: response.login ?? '',
			firstName: response.firstname ?? '',
			lastName: response.lastname ?? '',
			mail: response.mail ?? '',
			primaryOrganizationId: response.organization.id ?? undefined,
			accounts: Map(tuple),
		});
	}

	private generateRoles(account: AccountResponse): Array<RoleType> {
		let roles = [...account.userRoles];
		if (!account.groups) {
			return roles;
		}
		if (account.groups) {
			roles = account.groups.reduce((acc, accountGroup) => {
				accountGroup.roles.forEach((r) => acc.push(r));
				return acc;
			}, roles);
		}
		return roles;
	}

	public generateAvailableInstanceModules(
		availableInstanceModules: ReadonlyArray<IInstanceModel>,
		location: Location,
	): Map<number, InstanceModule> {
		const instances = availableInstanceModules
			.filter(
				(inst) => inst.publicUrl && !location.origin.includes(inst.publicUrl),
			)
			.map<[number, InstanceModule]>((item) => [
				item.id,
				InstanceModule.build({
					id: item.id,
					title: item.label ?? 'Titre non indiqué',
					type: item.type ?? ProductInstanceTypeModel.DcMarketplace,
					publicUrl: item.publicUrl,
				}),
			]);

		return Map(instances);
	}
}
